import { useMemo, type ReactNode } from 'react';
import { FormFieldContext } from './formFieldContext';
import { DEFAULT_FORM_FIELD_VARIANT } from './formField.config';
import type { FormFieldSize, FormFieldVariant } from './formField.types';

export interface FormFieldProviderProps {
  variant?: FormFieldVariant;
  size?: FormFieldSize;
  children: ReactNode;
}

export function FormFieldProvider({
  variant = DEFAULT_FORM_FIELD_VARIANT,
  size = 'large',
  children,
}: FormFieldProviderProps) {
  const value = useMemo(() => ({ variant, size }), [variant, size]);

  return <FormFieldContext.Provider value={value}>{children}</FormFieldContext.Provider>;
}
